import { PageTable, Header } from "/src/layouts/page";
import ModalManager from "@ebay/nice-modal-react";
import NiceModal from "@ebay/nice-modal-react";

import ApiModal from "/src/components/modal/ApiModal/ApiModal";

import { useNavigate } from "react-router-dom";

import Table from "/src/components/table";
import "./UserTable.css";
import UserModal from "../modal/UserModal";

import userService from '../../services/userService';
import storage from '/src/utils/storage';
import hasPermission from '/src/utils/hasPermission';
import { formatDateWithoutSeconds } from '/src/utils/dateWithoutSeconds';
import roleAdmin from '../../../role/assets/role-superadmin.png'
import roleUser from '../../../role/assets/role-partners.png'
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import { switchCompany } from '/src/utils/switchCompany';
import urlWithRoutingCompany from '/src/utils/urlWithRoutingCompany';
import { NavLink, useLocation} from 'react-router-dom';
import auth from "../../services/sendPasswordService";
import React, { useState } from "react";

function UserTable() {
    const currentUser = storage("local").get("user");
    const { getUser, getUsers, deleteUser, updateUser } = userService;
    const toast = useToastDispatchContext();
    const navigate = useNavigate();

    const location = useLocation();
    const searchUrl = location.pathname.substring(0, location.pathname.lastIndexOf('/'));
    const handleSwitch = async (id) => {
        await switchCompany(id, navigate);
    };

    const { updatePassword } = auth;
    const [delayPasswordForgotten, setDelayDelayPasswordForgotten] = useState(true);

    var cells = [];
    if (currentUser.is_admin) {
        cells = [
            {
                column: "ID",
                name: "id",
                sort: true,
                show: (value) => value,
            },

            {
                column: "AVATAR",
                name: "picture",
                show: (value) => <img srcSet={value}></img>,
            },
            {
                column: "ORGANIZATIONS",
                name: ["company.logo", "company.name", "company.id"],
                show: ([logo, name, id]) => (
                    <img
                        srcSet={logo}
                        title={name}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleSwitch(id)}></img>
                ),
            },
            {
                column: "USERNAME",
                name: "username",
                sort: true,
                show: (value) => value,
            },
            {
                column: "EMAIL",
                name: "email",
                show: (value) => value,
            },
            {
                column: "Role",
                name: "roles",
                show: (value) => (
                    <div>
                        {value
                            .filter((role) => role.company_id === null)
                            .map((role, i) => (
                                <div key={i}>
                                    {role.id === 1 ? (
                                        <img src={roleAdmin} alt="Role Admin" />
                                    ) : (
                                        <img src={roleUser} alt="Role Admin" />
                                    )}
                                </div>
                            ))}
                    </div>
                ),
            },
            {
                column: "LAST CONNECTION",
                name: "last_login_at",
                show: (value) => (value ? formatDateWithoutSeconds(value, true) : "/"),
            },
        ];
    } else {
        cells = [
            {
                column: "AVATAR",
                name: "picture",
                show: (value) => <img srcSet={value}></img>,
            },
            {
                column: "USERNAME",
                name: "username",
                show: (value) => value,
            },
            {
                column: "EMAIL",
                name: "email",
                show: (value) => value,
            },
        ];
    }

    const showAddModal = ({ addRow }) =>
        NiceModal.show(UserModal, {
            title: currentUser.is_admin || hasPermission("add_user") ? "Create a new User" : "Add a User to company",
        }).then((company) => addRow(company));

    const showEditModal = async ({ row, updateRow }) => {
        await NiceModal.show(UserModal, {
            title: "Modify your User",
            data: { ...row },
        }).then(({user}) => updateRow(user))
    }

    const onClickAdd = () => navigate(searchUrl + "/create");
    const onClickUpdate = ({ row }) => navigate(searchUrl +"/update", { state: { data: row, type: "update" } })

    const onClickShowHistory = ({row}) => navigate(`/administration/user/logs`, {state: {data : row}})

    const onClickDelete = async ({ row, deleteRow }) => {
        const { id, username } = row;
        await ModalManager.show(ApiModal, {
            title: "Delete user " + username,
            body: "Do you really want to delete user " + username,
            api: {
                request: deleteUser,
                param: [row.id],
            },
            buttons: [
                { className: "validate", label: "Cancel", style: { marginRight: "20px" } },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
        }).then((res) => (res.error != null ? toast.error("Error", res.error) : deleteRow(id)));
    };  

    

    const onClickSendPassword = async({row}) => {
        if (delayPasswordForgotten == false) return;
        let dataToSend = { email: row.email };
        let mess = "Perfect! The user will get a new temporary password at the given email address";
        const [result, error] = await updatePassword(dataToSend);
        toast.success("Password Edit", mess);
        setDelayDelayPasswordForgotten(false);
        setTimeout(() => setDelayDelayPasswordForgotten(true), 4000);
    };

    var actions = [];
    if (currentUser.is_admin) {
        actions = [
            hasPermission('update_user') ? { className: "fas fa-paper-plane action-button send_password_action", style: {}, onClick: onClickSendPassword } : null,
            hasPermission('update_user') ? { className: "fas fa-edit action-button edit_action", style: {}, onClick: onClickUpdate } : null,
            //hasPermission('update_user') ? { className: "fas fa-edit action-button edit_action", style: {}, onClick: showEditModal } : null,
            hasPermission('update_user') ? { className: "fas fa-history action-button edit_action", style: {}, onClick: onClickShowHistory } : null,
            hasPermission('delete_user') ? { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete } : null,
        ].filter(action => action);
    }
    else {
        actions = [
            //hasPermission('update_user') ? { className: "fas fa-edit action-button edit_action", style: {}, onClick: showEditModal, condition : 'is_admin', condition_match : true } : null,
            hasPermission('update_user') ? { className: "fas fa-edit action-button edit_action", style: {}, onClick: onClickUpdate, condition : 'is_admin', condition_match : true } : null,
            hasPermission('delete_user') ? { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete, condition : 'is_admin', condition_match : true } : null,
        ].filter(action => action)
    }
    const buttons = [
        //hasPermission('add_user') ? { icon: "fas fa-plus", onClick: showAddModal } : null,
        hasPermission('add_user') ? { icon: "fas fa-plus", onClick: onClickAdd } : null
    ].filter(button => button);


    const filters = [{ type: "input", placeholder: "content", name: "term" }];

    const getUsersCallable = async (params) => {
        if (currentUser.is_admin == false) {
            params = { ...params, company_id: currentUser.company.id };
        }
        return await getUsers(params);
    };

    return (
        <PageTable>
            <Header title="Manage Users"></Header>
            <div className="entete-dataset">
                <div className="entete-dataset" style={{ width: "115px" }}></div>
            </div>

            <Table
                name="User"
                cells={cells}
                api={getUsersCallable}
                actions={actions}
                buttons={buttons}
                filters={filters}></Table>
        </PageTable>
    );
}

export default UserTable;
